import React from 'react';
import { RadioGroup, Checkbox } from '@amzn/awsui-components-console';
import { SearchMode, SEARCH_MODE } from '../SearchPage';
import styles from './SearchTypeToggle.module.scss';

interface SearchTypeToggleProps {
  readonly mode: SearchMode;
  readonly exactMatch: boolean;
  readonly onModeChange: (mode: SearchMode) => void;
  readonly onExactMatchChange: (exactMatch: boolean) => void;
}

/**
 * Search type toggle: Source String / Translation radio + Exact Match checkbox.
 * Per mockup, all controls sit on a single inline row (no wrapping).
 * Uses flexbox with nowrap to enforce single-line layout.
 */
const SearchTypeToggle: React.FC<SearchTypeToggleProps> = ({
  mode,
  exactMatch,
  onModeChange,
  onExactMatchChange,
}) => {
  return (
    <div className={styles.container} data-testid="search-type-toggle">
      <RadioGroup
        value={mode}
        onChange={({ detail }) => onModeChange(detail.value as SearchMode)}
        direction="horizontal"
        items={[
          { value: SEARCH_MODE.SOURCE, label: 'Source string' },
          { value: SEARCH_MODE.TRANSLATION, label: 'Translation' },
        ]}
      />
      <div className={styles.divider} aria-hidden="true" />
      <Checkbox
        checked={exactMatch}
        onChange={({ detail }) => onExactMatchChange(detail.checked)}
      >
        Exact match
      </Checkbox>
    </div>
  );
};

export default SearchTypeToggle;
